import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { LinkCardProps } from './LinkCard';
import { EmbeddedMinimalCard } from './MinimalCardFront';

export const LazyLinkCard: FunctionComponent<LinkCardProps> = (props) => {
  const LinkCard = useLazyComponent(
    () => import(/* webpackChunkName: "link-card" */ './LinkCard'),
    { namedImport: 'LinkCard' },
  );

  const { idCard, url } = props;
  const fallback = <EmbeddedMinimalCard cardId={idCard} name={url} url={url} />;
  return (
    <ChunkLoadErrorBoundary fallback={fallback}>
      <Suspense fallback={fallback}>
        <LinkCard {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
